import { render, staticRenderFns } from "./ProjectStatsGraph.vue?vue&type=template&id=72c46973&scoped=true"
import script from "./ProjectStatsGraph.vue?vue&type=script&lang=js"
export * from "./ProjectStatsGraph.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatsGraph.vue?vue&type=style&index=0&id=72c46973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c46973",
  null
  
)

export default component.exports